var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"images"})]),_c('div',{staticClass:"col-md-6"})])
}
var staticRenderFns = []

export { render, staticRenderFns }